"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableTitleProperty = exports.resultsTableTitlePropertyDefinition = void 0;
exports.resultsTableTitlePropertyDefinition = {
    view: { label: 'Results Table Title' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'results-table-title',
};
const isResultsTableTitleProperty = (prop) => {
    return prop.name === exports.resultsTableTitlePropertyDefinition.name;
};
exports.isResultsTableTitleProperty = isResultsTableTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS10aXRsZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtdGl0bGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxtQ0FBbUMsR0FBRztJQUNqRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUscUJBQXFCLEVBQUU7SUFDdEMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHFCQUFxQjtDQUNJLENBQUE7QUFJMUIsTUFBTSwyQkFBMkIsR0FBRyxDQUFDLElBQWtCLEVBQXFDLEVBQUU7SUFDbkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDJDQUFtQyxDQUFDLElBQUksQ0FBQTtBQUMvRCxDQUFDLENBQUE7QUFGWSxRQUFBLDJCQUEyQiwrQkFFdkMifQ==